'use strict'
const ApiService = require('../_provider.api'),
	Axios = require('axios'),
	config = require('main.config')


class ChatService extends ApiService {

	constructor(init) {
		super(init);
	}

	getMessageUnreadCount({ uuid, isHilda }) {
		let data;
		if (isHilda) {
			data = {
				'query': 'query UnreadCount($subscribeKey: String!, $uuid: String!)  { unreadCount(subscribeKey: $subscribeKey, uuid: $uuid) }',
				'variables': {
					subscribeKey: config.chatHildaSubscribeKey,
					uuid: uuid
				},
				operationName: 'UnreadCount'
			};
		} else {
			data = {
				'query': 'query UnreadCount($subscribeKey: String!, $suSubscribeKey: String!, $uuid: String!)  { unreadCount(subscribeKey: $subscribeKey, uuid: $uuid) specialUserUnreadCount: unreadCount(subscribeKey: $suSubscribeKey, uuid: $uuid)}',
				'variables': {
					subscribeKey: config.chatSubscribeKey,
					suSubscribeKey: config.chatSpecialUserSubscribeKey,
					uuid: uuid
				},
				operationName: 'UnreadCount'
			};
		}
		return Axios({
			method: 'POST',
			url: config.chatBackendBaseUrl + '/securegraphql',
			data: JSON.stringify(data),
			headers: {
				'Content-Type': 'application/json'
			},
			withCredentials: true
		})
	}
}

module.exports = ChatService



// WEBPACK FOOTER //
// providers/providers/Chat.js